































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'CertificationQuestioner',
  components: {},
})
export default class CertificationQuestioner extends Vue {
  $moment: any;
  $wlToastr: any;
  private agreeTermsCheckbox = false;
  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop () isLastStep;
  @Watch('certificationQuestionList')
  onGetCertificationQuestion(val) {
    const agreeTermsQuestion = val[0].questionList.find(
      (question) => question.questionType === '09',
    );
    const checkTerms = !(
      agreeTermsQuestion.userQuestionResponse &&
      agreeTermsQuestion.userQuestionResponse.userAnswerList[0]
    );
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep ? checkTerms : this.isRequiredStep) : checkTerms;
    this.$emit('disable-next-button', disable);
  }
  mounted() {
    vxm.users.listCertificationQuestions();
    this.bus.$on('on-next-step', this.onNextStep);
    this.$emit('disable-next-button', true);
    this.$emit('update-next-text', 'Submit');
  }

  get certificationQuestionList() {
    return vxm.users.CertificationQuestionList;
  }
  async onNextStep() {
    try {
      await vxm.users.saveCertificateAnswers(vxm.users.myUserProfile.userId);
      await vxm.users.validateMandatorySteps();
      if (vxm.users.MissedMandatorySteps.length  && this.isLastStep) {
        this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
      } else {
        await vxm.users.getProfileStrength();
        this.$emit('go-to-next');
      }
    } catch (e) {
      this.$wlToastr('error', e, 'Certification Questions');
    }
  }
  relaunchGuidedSignup() {
    this.$emit('relaunch-guided-signup');
  }

  get missedMandatorySteps() {
    return vxm.users.MissedMandatorySteps;
  }

  setSelectedAnswer(event, questionID, answerID) {
    vxm.users.setSelectedCertificationAnswer({ questionID, answerID });
  }
  beforeDestroy() {
    vxm.users.setMissedMandatorySteps([]);
    this.$emit(
      'update-next-text',
      this.$t('global-save-continue-text').toString(),
    );
    this.bus.$off('on-next-step');
  }
  isChecked(question, answerID) {
    if (
      question.userQuestionResponse &&
      question.userQuestionResponse.userAnswerList &&
      question.userQuestionResponse.userAnswerList[0] &&
      question.userQuestionResponse.userAnswerList[0] === answerID
    ) {
      return 'checked';
    }
    return '';
  }
  agreeTerms(event, questionID, answerID) {
    vxm.users.setSelectedCertificationAnswer({
      questionID,
      answerID: event.target.checked ? answerID : '',
    });
  }
  requiredQuestion(question) {
    if (question.questionRequired === true) return question.questionDesc + ' *';
    else return question.questionDesc;
  }
}
